import React from "react";
import PropTypes from "prop-types";
import {Box} from "@mui/material";
import Collapsible from "../collapsible/Collapsible";

const ChatbotCollapsible = ({title, expanded = false, children}) => (
  <Collapsible title={title} expanded={expanded}>
    <Box
      component="pre"
      sx={{fontSize: "0.875rem", overflow: "auto", margin: 0}}
    >
      {children}
    </Box>
  </Collapsible>
);

ChatbotCollapsible.propTypes = {
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
  children: PropTypes.node,
};

export default ChatbotCollapsible;
